<img [defaultImage]="defaultImage" [lazyLoad]="src" (click)="openImage(0)" (onStateChange)="handler($event)" [offset]="500" [alt]="alt">
